export const allAppFilterInitialValues = {
	number: "",
	mid: "",
	merchantName: "",
	merchantStatus: "",
	processor: "",
	sponsor: "",
	agentOffice: "",
	agentName: "",
	applicationStatus: "",
	assignedTo: "",
};

export const signedMPAFilterInitialValues = {
	number: "",
	merchantName: "",
	processor: "",
	sponsor: "",
	agentOffice: "",
	agentName: "",
	assignedTo: "",
};

export const preAppFilterInitialValues = {
	number: "",
	merchantName: "",
	processor: "",
	sponsor: "",
	agentOffice: "",
	agentName: "",
	assignedTo: "",
};

export const pendAppFilterInitialValues = {
	number: "",
	mid: "",
	merchantName: "",
	merchantStatus: "",
	processor: "",
	sponsor: "",
	agentOffice: "",
	agentName: "",
	applicationStatus: "",
	pendStatus: "",
	pendedTo: "",
	assignedTo: "",
};

export const draftFilterInitialValues = {
	number: "",
	merchantName: "",
	processor: "",
	sponsor: "",
	agentOffice: "",
	agentName: "",
	assignedTo: "",
};
